import * as React from "react";
import { PageHeader } from "@/components/page-header/PageHeader";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { routeFactory } from "../../../../../RouteFactory";
import { Customer, HeadAgreement } from "../types";
import { BreadCrumbs } from "@stenajs-webui/elements";

interface Props {
  customer: Customer;
  headAgreement: HeadAgreement;
}

export const CopyHeadAgreementHeader: React.FC<Props> = ({
  customer,
  headAgreement,
}) => {
  return (
    <PageHeader
      title={"Copy header agreement"}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={customer?.breadCrumbName ?? ""}
            path={routeFactory.productAndPrice.customer.customer({
              customerId: customer.id,
            })}
          />
          <Crumb
            label={String(headAgreement?.headAgreementNumber ?? "")}
            path={routeFactory.productAndPrice.customer.customerHeadAgreement({
              customerId: customer.id,
              headAgreementId: headAgreement.id,
            })}
          />
          <Crumb label={"copy"} />
        </BreadCrumbs>
      }
    />
  );
};
